import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { formatearFechaMoment_a_StringFormatoReporte, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { validarFechaMomentEnFormatoString } from '../../funciones_globales/utils';
import { cargarCatalogos_Otros } from '../../funciones_globales/catalogos';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

class FormBanco10  extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            fechaDesde: null,
            fechaHasta: null,
            cuentasBancarias: [],
            tiposMovimientoBco: [],
            tipoMov_sel: null,
            ctaBanco_sel: null
        };
        
        this.limpiar = this.limpiar.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.generarReporteMovAnulados = this.generarReporteMovAnulados.bind(this);
    }
    
    componentDidMount(){
        Promise.all([
            cargarCatalogos_Otros('TIPODOC-BAN'),
            cargarCatalogos_Otros('BAN-CTASDEP'),
            this.props.generar_LogAuditoriaIngresoForm('0710')
        ])
        .then(([ tiposMovBanco, ctasBancarias ]) => {
            let fechaProceso = getFechaProcesoPorModulo('07');            
            this.setState({ fechaDesde: moment(fechaProceso, "DD/MM/YYYY"),
                            fechaHasta: moment(fechaProceso, "DD/MM/YYYY"),
                            tiposMovimientoBco: tiposMovBanco,
                            cuentasBancarias: ctasBancarias
                        });
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0710');
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }

    generarReporteMovAnulados(){        
        try {

            let fechaDesde = formatearFechaMoment_a_String(this.state.fechaDesde);
            if (!validarFechaMomentEnFormatoString(fechaDesde)){
                alert('La fecha Desde es inválida.');
                return;
            }
            
            let fechaHasta = formatearFechaMoment_a_String(this.state.fechaHasta);
            if (!validarFechaMomentEnFormatoString(fechaHasta)){
                alert('La fecha Hasta es inválida.');
                return;
            }

            if(this.state.fechaHasta.diff(this.state.fechaDesde, 'days')<0){        
                alert(`La fecha Desde debe ser menor a: ${formatearFechaMoment_a_String(this.state.fechaHasta)}`);
                return;
            }
            
            let urlReportWithParams =`&rpt=56&param1=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)}`;
            urlReportWithParams += `&param2=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta)}`;
            
            if(this.state.tipoMov_sel !== null){
                urlReportWithParams += `&param3=${this.state.tipoMov_sel}`;
            }

            if(this.state.ctaBanco_sel !== null){
                urlReportWithParams += `&param4=${this.state.ctaBanco_sel}`;
            }
            
            visualizarReporteEnPdf(urlReportWithParams);
        } catch (error) {
            alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
        }
    }

    limpiar(){
        let fechaProceso = getFechaProcesoPorModulo('07');        
        this.setState({ fechaDesde: moment(fechaProceso, "DD/MM/YYYY"),
                        fechaHasta: moment(fechaProceso, "DD/MM/YYYY"), tipoMov_sel: null,
                        ctaBanco_sel: null
        });
    }

    render(){
        return (
            <ContenedorForm porc_ancho={60}>
            <HeaderForm>
                <TituloForm>Movimientos Banco Anulados</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <Row>
                        <ContainerCol className='col-sm-1' margen_arriba={20}>
                            <LabelForm>Desde:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2' margen_arriba={20}>
                            <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fecha)=>{this.setState({fechaDesde: fecha});}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-1' margen_arriba={20}>
                            <LabelForm>Hasta:</LabelForm>                        
                        </ContainerCol>
                        <ContainerCol className='col-sm-2' margen_arriba={20}>
                            <PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fecha)=>{this.setState({fechaHasta: fecha});}}/>                        
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-1' margen_arriba={10}>
                            <LabelForm>Tipo:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-5' margen_arriba={10}>
                            <ReactSelect options={ this.state.tiposMovimientoBco } value={this.state.tipoMov_sel} 
                                func_onChange={(value)=>{this.setState({tipoMov_sel: value!==null?value.value:null})}}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-1' margen_arriba={10}>
                            <LabelForm>Cuenta:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-5' margen_arriba='15' margen_abajo='4'>
                            <ReactSelect options={ this.state.cuentasBancarias } value={this.state.ctaBanco_sel}
                                func_onChange={(value)=>{this.setState({ctaBanco_sel: value!==null?value.value:null})}}/>
                        </ContainerCol>
                    </Row> 
                    <Row>
                        <ContainerCol className='col-sm-12' margen_arriba={10}>
                            <div className='btn-group pull-right'>                            
                                <button type='button' className='btn btn-info btn-sm' onClick={this.generarReporteMovAnulados}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>  
                                <button type="button" className='btn btn-sm' onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
    return {permiso: state.sesion.valoresSesionForm.Permiso,
            usuario: state.sesion.valoresSesionForm.Usuario
        }
});
  
const mapDispatchToProps = ((dispatch) => {  
return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormBanco10);